export default __webpack_public_path__ + "static/2-29999dd723a25ad7083f69afce69f789.jpeg";